import { render, staticRenderFns } from "./BillingInformation.vue?vue&type=template&id=0706b77b"
import script from "./BillingInformation.vue?vue&type=script&lang=js"
export * from "./BillingInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports